import React from "react";
import { Facebook, Instagram, Twitter, Phone, MapPin, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function QuickContactSiteInfo() {
  const currentYear = new Date().getFullYear();
  const services = ["Bathroom Remodeling", "Kitchen Remodeling", "Basement Remodeling", "Custom Walk-in Showers", "Tile Installation", "Custom Cabinetry"];
  const serviceAreas = ["Hudson", "River Falls", "Prescott", "Ellsworth"];
  return <section data-section-id="7177" id="footer" className="bg-background text-muted-foreground py-12 md:py-16 border-t border-accent/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col items-start gap-4">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/plumbers_pipes_logo.png" alt="Finely Done Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs font-sans">
              Family-owned and faith-based since 2004. Delivering premium
              craftsmanship and dedicated remodeling services to the St. Croix Valley community.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-serif font-bold text-xl">Services</h3>
            <ul className="flex flex-col gap-2.5">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/GalleryPage" className="text-sm font-sans hover:text-accent transition-colors duration-200">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-serif font-bold text-xl">
              Service Areas
            </h3>
            <ul className="flex flex-col gap-2.5">
              {serviceAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to="/ContactPage" className="text-sm font-sans hover:text-accent transition-colors duration-200">
                    {area}, WI
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-serif font-bold text-xl">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span className="text-xs uppercase tracking-widest font-sans font-bold text-foreground/80">
                    Phone
                  </span>
                  <Link to="tel:+17156889336" className="text-foreground hover:text-accent transition-colors font-sans font-medium">
                    (715) 688-9336
                  </Link>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span className="text-xs uppercase tracking-widest font-sans font-bold text-foreground/80">
                    Location
                  </span>
                  <span className="text-sm font-sans">
                    Hudson, WI 54016
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <ShieldCheck className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span className="text-xs uppercase tracking-widest font-sans font-bold text-foreground/80">
                    Status
                  </span>
                  <span className="text-sm font-sans">Licensed & Insured</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-border/40 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 font-sans">
            <p>© {currentYear} Finely Done. All rights reserved.</p>
            <Link to="#" className="hover:text-accent transition-colors duration-200">
              Privacy Policy
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <Link to="https://facebook.com" newTab className="p-2 rounded-sm bg-primary/5 hover:bg-accent hover:text-white transition-all duration-300" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </Link>
            <Link to="https://instagram.com" newTab className="p-2 rounded-sm bg-primary/5 hover:bg-accent hover:text-white transition-all duration-300" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </Link>
            <Link to="https://twitter.com" newTab className="p-2 rounded-sm bg-primary/5 hover:bg-accent hover:text-white transition-all duration-300" aria-label="Twitter">
              <Twitter className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}